import { ModelBase } from "../core/modelbase";

export class Holiday extends ModelBase {
  hoKey: string;
  hoName: string;
  hoDate: Date;
}
